import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { Router } from '@angular/router'
import { Subscription } from 'rxjs';
import { NotiService } from '@app/noti.service';
import { TranslateService } from '@ngx-translate/core';
import { timer } from 'rxjs/observable/timer'
import { elementStyle } from '@angular/core/src/render3/instructions';
import { ignoreElements } from 'rxjs/operator/ignoreElements';


declare var $: any, moment: any
@Component({
  selector: 'app-request-document',
  templateUrl: './request-document.component.html',
  styleUrls: ['./request-document.component.scss']
})
export class RequestDocumentComponent implements OnInit {
  combinedAddressList: any
  combinedAddressListEn: any
  form: FormGroup
  formSave: FormGroup
  isCompany = false
  isForeign = false
  cookieData: any
  submitted = false
  contact: any
  contactDROS: any
  crm03Obj: any = []
  isConsentAccept = false
  isShownConsent = false
  allowNews = false
  lang = "th"
  disablebtnSave = false

  
  saveOK = false

  showReqNewDocForm = true
  showOtp = false
  lastReqTime: any
  disableResentOtp = false
  totolWaitResend = 59
  telephoneOtp = ""
  otp = ""
  otpRef = ""
  requestOtpLbl = "ขอรหัส OTP"
  requestOtpLblTmp = "ขอรหัส OTP"
  otpTimer: any = ""
  ElapseTime: number = 0;
  TotalTime: number = 0;
  OTPCountDown: string = "";
  SubScr: Subscription;

  crm08DROS: any
  crm08DROSList: any = []

  private notiSubscription: Subscription;
  constructor(
    private router: Router,
    private fb: FormBuilder,
    private util: UtilService,
    private apiService: ApiService,
    private translate: TranslateService,
    private notiService: NotiService) {
    this.form = this.fb.group({
      dpa_companyname: "",
      dpa_companytypeid: "",
      dpa_registrationid: "",

      dpa_authorizedperson: "",
      dpa_authorizedperson_idcard: "",
      dpa_authorizedperson_telephone: "",

      contactid: "",

      firstname: ['', Validators.required],
      lastname: ['', Validators.required],
      dpa_idcard: "",
      telephone1: ['', Validators.required],
      emailaddress1: ['', this.emailValidator],
      birthdate: "",
      dpa_accountno: "",
      dpa_contact_homeno: ['', Validators.required],
      dpa_contact_moo: "",
      dpa_contact_street: "",
      dpa_contact_subdistict: "",
      dpa_contact_distict: "",
      dpa_contact_province: "",
      dpa_contact_postcode: "",
      dpa_contact_country: "",

      dpa_contact_subdistictname: "",
      dpa_contact_distictname: "",
      dpa_contact_provincname: "",
      dpa_contact_postcodename: "",
      dpa_contact_countryname: "",

      dpa_allowemail: false,
      dpa_allowsms: false,
      dpa_portalflag: true,
      pid: ""
    });

  }

  ngOnDestroy() {
    if (this.notiSubscription) {
      this.notiSubscription.unsubscribe();
    }
  }

  async ngOnInit() {
    let thisTs = this

    let PortalUser: any = JSON.parse(localStorage.getItem("dpa_portal"));

    if (PortalUser == null || PortalUser.contactid == null || PortalUser.contactid == "") {
      this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
      $("#btnWarningOK").off("click");
      $("#btnWarningOK").click(function () {
        thisTs.router.navigate(["/mainmenu/login"]);
      });
      return;
    }

    this.util.ShowWaiting(true)


    if (this.lang == "th") {
      $(".select2-en").hide()
      $(".select2-th").show()
    }
    else {
      $(".select2-th").hide()
      $(".select2-en").show()
    }

    this.notiSubscription = this.notiService.message.subscribe(_lang => {
      this.lang = _lang
      if (this.lang == "th") {
        $(".select2-en").hide()
        $(".select2-th").show()
      }
      else {
        $(".select2-th").hide()
        $(".select2-en").show()
      }
      if (this.contact != null) {
        $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change')
      }

      //this.bindAddress(this.lang)
    });

    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if (this.cookieData == null) {
      this.cookieData = {}
    }

    function matchCustom(params: any, data: any) {
      // If there are no search terms, return all of the data
      if ($.trim(params.term) === '') {
        return data;
      }

      // Do not display the item if there is no 'text' property
      if (typeof data.text === 'undefined') {
        return null;
      }

      if (params.term.length > 1) {
        // `params.term` should be the term that is used for searching
        // `data.text` is the text that is displayed for the data object
        let cris = params.term.split(" ")
        let found = true
        for (var i = 0; i < cris.length; i++) {
          if (cris[i] != '' && data != null && data.text != null && data.text.toLowerCase().indexOf(cris[i].toLowerCase()) < 0) {
            found = false;
            return null
          }
        }
        if (found) {
          // You can return modified objects from here
          // This includes matching the `children` how you want in nested data sets
          return data;
        }

      }
      // Return `null` if the term should not be displayed
      return null;
    }

    $('.select2th').select2({
      matcher: matchCustom,
      placeholder: "โปรดพิมพ์รายละเอียดที่อยู่"
    });

    $('.select2en').select2({
      matcher: matchCustom,
      placeholder: "Please select your address."
    });

    $(".select2").on("change", function (e: any) {
      thisTs.addressChange(e.target.value)
    })

    await this.initdropdown()

    this.contact = await this.getContact()
    if (this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0)
    {
    this.contactDROS = await this.getContactDROS(this.contact.dpa_registrationid)
    }    
    else if (this.contact.dpa_passport != null && this.contact.dpa_passport.trim().length > 0)
    {
    this.contactDROS = await this.getContactDROS(this.contact.dpa_passport)
    }
    else
    {
      this.contactDROS = await this.getContactDROS(this.contact.dpa_idcard)
    }
    // this.crm03Obj = this.contactDROS.CRM03
    let hasrow = false;
    if (!this.util.IsNullOrUndefined(this.contactDROS.CRM03)) {
      for (let itm of this.contactDROS.CRM03) {
        if (!this.util.IsNullOrUndefined(itm.FilePath)) 
        {  
          if(itm.FilePath.split('_')[1] != "05.pdf" && itm.FilePath.split('_')[1] != "07.pdf")
          {
            if(itm.IsPrint != 1)
            {
              hasrow = true;
            }

            let reqdetail: any = { 
              RequestedNo: itm.RequestedNo, 
              RequestType : itm.RequestType, 
              isPrintMessage : itm.IsPrint == 1 ? "มีการขอเอกสารแล้ว" : ("สามารถขอเอกสารได้"),
              UID : itm.UID,
              isPrint : itm.IsPrint,

            }
            

            this.crm03Obj.push(reqdetail);
          }
        }
      }
    }
    if(!hasrow)
    {
      this.disablebtnSave = true;
      //$("#savedata").addClass("sr-only");
    }

    if (!this.util.IsNullOrUndefined(this.crm03Obj) && this.crm03Obj.length == 0) {
      $("#divNoData").removeClass("colhidden");
      //$("#savedata").addClass("sr-only");
      this.disablebtnSave = true;
    }


    if (this.cookieData != null) {
      this.contact.pid = this.cookieData.pid
    }

    this.mapDataToForm(this.contact)
    $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change')

    this.allowNews = this.contact.dpa_allowemail || this.contact.dpa_allowsms
    if (this.contact != null && this.contact.birthdate != null && this.contact.birthdate.trim().length != 0) {
      $("#dob").datepicker("setDate", new Date(this.contact.birthdate))
    }

    if (this.contact.dpa_companytypeid != null && this.contact.dpa_companytypeid.trim().length > 0) {
      this.isCompany = true

      let firstname = ""
      let lastname = ""
      try {
        let name: string = this.contact.dpa_authorizedperson.split(" ")
        if (name.length > 0) {
          if (name.length == 1) {
            firstname = name[0]
          }
          else if (name.length == 2) {
            firstname = name[0]
            lastname = name[1]
          }
          else {
            for (let i = 0; i < name.length - 1; i++) {
              firstname += " " + name[i]
            }
            firstname = firstname.trim()
            lastname = name[name.length - 1]
          }
        }
      }
      catch (e) {
        console.log(e)
      }

      this.form.controls["firstname"].setValue(firstname)
      this.form.controls["lastname"].setValue(lastname)
    }
    else {
      this.isForeign = this.contact != null && this.contact.dpa_passport != null && this.contact.dpa_passport.trim() != ''
    }


    $('#chkboxAll').click(function () {
      var $that = $(this);
      $(':checkbox').each(function () {
        this.checked = $that.is(':checked');
      });
    });
  }

  async goToClick(event: any) {
    this.crm08DROSList = [];
    let accNo = event.target.id;
    //localStorage.setItem('acccountNo', accNo);
    //this.router.navigate(["/mainmenu/statusReqNewDocument"]);

    this.lang = this.util.GetCurrentLang();
    let thisTs = this;

    let PortalUser: any = JSON.parse(localStorage.getItem("dpa_portal"));

    if (PortalUser == null || PortalUser.contactid == null || PortalUser.contactid == "") {
      this.util.WarningDialog("กรุณาเข้าสู่ระบบ");
      $("#btnWarningOK").off("click");
      $("#btnWarningOK").click(function () {
        thisTs.router.navigate(["/mainmenu/login"]);
      });
      return;
    }

    this.util.ShowWaiting(true)
    this.cookieData = JSON.parse(localStorage.getItem("dpa_portal"))
    if (this.cookieData == null) {
      this.cookieData = {};
    }

    this.contact = await this.getContact();
    this.contactDROS = await this.getContactDROS(this.contact.dpa_idcard)
    if (!this.util.IsNullOrUndefined(this.contactDROS.CRM06)) {
      this.crm08DROS = await this.getCRM08DROS(this.contactDROS.CRM06.UID);
      if (!this.util.IsNullOrUndefined(this.crm08DROS) && this.crm08DROS.length > 0) {
        for (let itm of this.crm08DROS) {
          if (itm.DROSRequestNo == accNo){
            let docStatus: string;
            if (itm.SentStatus === "1") { docStatus = "ส่งสำเร็จ" }
            else if (itm.PrintStatus === "1") { docStatus = "อยู่ระหว่างจัดพิมพ์" }
            else if (itm.IsRead === "1") { docStatus = "ได้รับข้อมูล" }
            else { docStatus = "ยื่นคำขอเอกสารใหม่" }
            let rowDisplay: any = { CRMRequestNo: itm.CRMRequestNo, DROSRequestNo: itm.DROSRequestNo, DocumentCode: itm.DocumentCode, UID: itm.UID, Status: itm.Status, ErrorCode: itm.ErrorCode, Address: itm.Address, MooNo: itm.MooNo, StreetName: itm.StreetName, LocationCode: itm.LocationCode, Zipcode: itm.Zipcode, PhoneNo: itm.PhoneNo, Email: itm.Email, CreateOn: this.DisplayDate(itm.CreateOn), ModifiedOn: itm.ModifiedOn, ProcessStatus: docStatus };
            this.crm08DROSList.push(rowDisplay);
          }
        }
      }
    }

    this.combinedAddressList = await this.getAddressAll();

    this.util.ShowWaiting(false);
    $("#frmStatusReqNewDoc").removeClass("hideDiv").addClass("animate-opacity");
  }

  async getCRM08DROS(uid: string) {
    let para = "UID=" + uid;
    let tmp: any = await this.apiService.get("crmservice", "getCRM08DROS", para);
    return tmp;
  }

  async getAddressAll() {
    let tmp: any = await this.apiService.getMasterAddress();
    return tmp;
  }

  DisplayDate(sdate: string) {
    let result: string = "";
    let enDate: string[] = sdate.split('T')[0].split('-');
    if (this.lang === "th-TH") {
      result = enDate[2] + "/" + enDate[1] + "/" + (parseInt(enDate[0]) + 543).toString();
    }
    else {
      result = enDate[2] + "/" + enDate[1] + "/" + enDate[0];
    }
    return result;
  }

  async initdropdown() {
    this.combinedAddressList = await this.apiService.getMasterAddress()
    this.setAddressEn()
    if (this.contact != null) {
      $(".select2").val(this.contact.dpa_contact_subdistict + "|" + this.contact.dpa_contact_distict + "|" + this.contact.dpa_contact_province + "|" + this.contact.dpa_contact_postcode + "|" + this.contact.dpa_contact_country).trigger('change')
    }
  }

  setAddressEn() {
    if (this.combinedAddressList != null && this.combinedAddressList.length > 0) {
      this.combinedAddressListEn = this.combinedAddressList.slice().sort(function (a: any, b: any) {
        if (a.text_eng < b.text_eng) {
          return -1;
        }
        if (a.text_eng > b.text_eng) {
          return 1;
        }
        return 0;
      });
    }
  }

  get formControl() {
    return this.form.controls;
  }

  addressChange(value: any) {
    let selected = this.combinedAddressList.filter((a: any) => a.id == value)
    if (selected != null && selected.length > 0) {
      let values = selected[0].id.split("|")
      let texts: any
      if (this.lang == "th") {
        texts = selected[0].text.split(" | ")
      }
      else {
        texts = selected[0].text_eng.split(" | ")
      }

      this.formControl["dpa_contact_subdistict"].setValue(values[0])
      this.formControl["dpa_contact_distict"].setValue(values[1])
      this.formControl["dpa_contact_province"].setValue(values[2])
      this.formControl["dpa_contact_postcode"].setValue(values[3])
      this.formControl["dpa_contact_country"].setValue(values[4])

      this.formControl["dpa_contact_subdistictname"].setValue(texts[0])
      this.formControl["dpa_contact_distictname"].setValue(texts[1])
      this.formControl["dpa_contact_provincname"].setValue(texts[2])
      this.formControl["dpa_contact_postcodename"].setValue(texts[3])
      this.formControl["dpa_contact_countryname"].setValue(texts[4])
    }
    else {
      this.formControl["dpa_contact_subdistict"].setValue("")
      this.formControl["dpa_contact_distict"].setValue("")
      this.formControl["dpa_contact_province"].setValue("")
      this.formControl["dpa_contact_postcode"].setValue("")
      this.formControl["dpa_contact_country"].setValue("")

      this.formControl["dpa_contact_subdistictname"].setValue("")
      this.formControl["dpa_contact_distictname"].setValue("")
      this.formControl["dpa_contact_provincname"].setValue("")
      this.formControl["dpa_contact_postcodename"].setValue("")
      this.formControl["dpa_contact_countryname"].setValue("")
    }
  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
      return matches ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }


  async CheckFormAndOTP() {
    this.submitted = true;
    if (!this.form.valid) {
      return false;
    }
    const selected: any = [];
    $("#tbcrm03 input[type=checkbox]:checked").each(function () {
      var row = $(this).closest("tr")[0];
      selected.push(row.cells[1].innerHTML);
    });

    if (selected.length == 0) {
      this.util.ErrorDialog("กรุณาเลือกเอกสารอย่างน้อย 1 รายการ");
      return false;
    }

    //this.telephoneOtp = this.isCompany ? this.form.get("dpa_authorizedperson_telephone").value : this.form.get("telephone1").value;
    //$("#frmReqNewDoc").hide();
    //this.showOtp = true;
    await this.save(); 
    if(this.saveOK){
      this.util.SuccessDialog("บันทึกข้อมูลสำเร็จ")
      $("#btnSuccessOK").click(async function () {
          
        window.location.reload();
        //this.router.navigate(["/mainmenu/index"])
      });
    }
  }


  async save() {
    let selected: any = [];
    let dataSave: any = [];
    $("#tbcrm03 input[type=checkbox]:checked").each(function () {
      var row = $(this).closest("tr")[0];
      let rowCRM03: any = {
        reqNoDROS: row.cells[1].innerHTML,
        UID: row.cells[4].innerHTML
      }
      selected.push(rowCRM03);
    });
    for (const itm of selected) {
      let rowSave: any = {
        CRMRequestNo: "",
        DROSRequestNo: itm.reqNoDROS,
        DocumentCode: "",
        UID: itm.UID,
        Status: "P",
        ErrorCode: "",
        Address: this.form.get("dpa_contact_homeno").value,
        MooNo: this.form.get("dpa_contact_moo").value,
        StreetName: this.form.get("dpa_contact_street").value,
        LocationCode: this.form.get("dpa_contact_subdistict").value,
        Zipcode: this.form.get("dpa_contact_postcodename").value,
        PhoneNo: this.isCompany ? this.form.get("dpa_authorizedperson_telephone").value : this.form.get("telephone1").value,
        Email: this.form.get("emailaddress1").value,
        IsRead: "",
        PrintStatus: "",
        SentStatus: "",
        CreateOn: "",
        ModifiedOn: ""
      }

      dataSave.push(rowSave);
    }

    await this.apiService.post("crmservice", "UpdateCRM08DROS", dataSave).then((res: any) => {
      if (res != null && res["Status"] != null && parseInt(res["Status"]) == 200) { 
        
        //let thisTs = this
          this.saveOK = true;
      }
      else if (res != null && res["Status"] != null && parseInt(res["Status"]) == 201)
      {
        this.util.WarningDialog("บันทึกข้อมูลไม่สำเร็จ มีคำขอซ้ำในระบบ")
      }
      else {
        this.util.ErrorDialog("บันทึกข้อมูลไม่สำเร็จ")
      }
      this.util.ShowWaiting(false)
    });

    this.clearFrmOTP();

  }


  close() {
    //window.close()
    this.router.navigate(["/mainmenu/index"]);
  }

  telephoneOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {

      if (charCode == 35 || charCode == 44) {
        return true
      }
      return false;
    }
    return true;
  }

  numberOnly(event: any) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async getContact() {
    let para = "contactid=" + this.cookieData.contactid
    let tmp: any = await this.apiService.get("crmservice", "contact", para)
    return tmp[0]
  }

  async getContactDROS(idcard: string) {
    //dpa_id=3100036975212&telephoneno=0-2227-9200&fullname=PARK YOU MEE 2&CRM05=true&CRM04=true&CRM03=true&CRM02=true&CRM07=true
    let para = "dpa_id=" + idcard + "&telephoneno=&fullname=&CRM05=false&CRM04=false&CRM03=true&CRM02=false&CRM07=false"
    let tmp: any = await this.apiService.get("crmservice", "contactDros", para)
    return tmp
  }



  mapDataToForm(data: any) {
    Object.keys(data).forEach((key) => {
      if (this.form.controls[key]) {
        this.form.controls[key].setValue(data[key])
      }
      else {
        this.form.addControl(key, new FormControl(data[key]));
      }
    });
    setTimeout(() => {
      this.util.ShowWaiting(false)
    }, 600);
  }

  isValidForm() {
    return true;
  }

  onCheckChange() {
    var totalCheckboxes = $('#tbcrm03 input:checkbox').length;
    var numberOfChecked = $('#tbcrm03 input:checkbox:checked').length;
    if (totalCheckboxes === numberOfChecked) {
      $('#chkboxAll').prop('checked', true);
    } else {
      $('#chkboxAll').prop('checked', false);
    }
  }

  cancelOtp() {
    $("#frmReqNewDoc").show();
    this.clearFrmOTP();
    this.showOtp = false;
 
  }
  async requestOtp() {
    this.util.ShowWaiting(true)
    let reqOtp: any = {
      MobileNo: this.telephoneOtp,
    }

    await this.apiService.postCustomApi("crm", "RequestOTP", reqOtp).then(async (reqOtpRes: any) => {
      if (this.util.isSuccessResponse(reqOtpRes)) {

        //reqOtpRes = this.util.AesDecryptDictValue(reqOtpRes.json())

        let smsContent = "รหัสตรวจสอบการยืนยันตัวตนของคุณคือ : "
        smsContent += reqOtpRes.otpNo + " "
        smsContent += "(RefCode : " +reqOtpRes.RefCode  
        smsContent += " ) (รหัสมีอายุ " + reqOtpRes.expInMinute + " นาที) อย่าเปิดเผยรหัสกับผู้อื่น"   

        let sendSms: any = {
          dpa_description: smsContent,
          dpa_phoneno: this.telephoneOtp
        }

        let sendSmsRes: any = await this.apiService.post("crmservice", "sendSms", sendSms)

        this.util.ShowWaiting(false)
        if (this.util.isSuccessResponse(sendSmsRes)) {
          $("#divOtp").removeClass("colhidden");
          this.otpRef = reqOtpRes.RefCode
          this.otpTimer = 59
          this.lastReqTime = new Date()
          this.requestOtpLblTmp = "ส่งอีกครั้ง"
          this.swithLbl()
          this.disableResentOtp = true
          this.countdown()
          if (reqOtpRes.expInMinute == undefined || reqOtpRes.expInMinute == null) {
            this.TotalTime = 300;
          }
          else {
            this.TotalTime = reqOtpRes.expInMinute * 60;
          }
          this.ElapseTime = 0;
          if (this.SubScr != undefined) {
            this.SubScr.unsubscribe();
          }
          this.SubScr = timer(0, 1000).subscribe(() => this.CountDownOTP());
        }
        else {
          this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
        }
      }
      else {
        this.util.ShowWaiting(false)
        this.util.ErrorDialog("เกิดข้อผิดพลาดในการ ขอ Otp กรุณาลองใหม่อีกครั้ง หรือติดต่อเจ้าหน้าที่")
      }
    })
  }

  swithLbl() {
    if (this.requestOtpLblTmp == "ขอรหัส OTP") {
      let lblTmp: any = this.translate.get("RequestOTP")
      this.requestOtpLbl = lblTmp.value
    }
    else {
      let lblTmp: any = this.translate.get("ResendOTP")
      this.requestOtpLbl = lblTmp.value
    }
  }
 
  countdown() {
    if (this.otpTimer > 0) {

      let dif = new Date().getTime() - this.lastReqTime.getTime();

      var Seconds_from_T1_to_T2 = dif / 1000;
      this.otpTimer = this.totolWaitResend - Math.round(Seconds_from_T1_to_T2)
      setTimeout(() => {
        this.countdown()
      }, 400);
    }
    else {
      this.disableResentOtp = false
    }
  }

  CountDownOTP() {
    if (this.ElapseTime == 0 && this.TotalTime == 0) {
      this.SubScr.unsubscribe();
      this.OTPCountDown = "";
      return;
    }
    if (this.ElapseTime == this.TotalTime) {
      this.SubScr.unsubscribe();
      this.ElapseTime = 0;
      this.OTPCountDown = "";
      return;
    }

    this.ElapseTime++;
    let RemainingSecs = this.TotalTime - this.ElapseTime;
    let RemainingMins = (RemainingSecs - (RemainingSecs % 60)) / 60;
    RemainingSecs = RemainingSecs % 60;
    this.OTPCountDown = " " + RemainingMins + ":" + (RemainingSecs < 10 ? "0" : "") + RemainingSecs;
  }

  clearFrmOTP() {
    this.otp = "";
    this.otpRef = "";
    this.otpTimer = 0;
    if (!this.util.IsNullOrUndefined(this.SubScr)) { this.SubScr.unsubscribe(); }
    this.ElapseTime = 0;
    this.OTPCountDown = "";
    this.requestOtpLbl = "ขอรหัส OTP";
    this.requestOtpLblTmp = "ขอรหัส OTP";
    $("#divOtp").addClass("colhidden");
    return;
  }


  async SubmitOTP() {
    if (this.otp.trim().length > 0) {

      this.util.ShowWaiting(true)

      let reqCheckOtp: any = {
        OTP: this.otp.trim(),
        RefCode: this.otpRef,
        MobileNo: this.telephoneOtp
      }

      let reqCheckOtpRes: any = await this.apiService.postCustomApi("crm", "VerifyOTP", reqCheckOtp)
      if (!this.util.IsNullOrUndefined(reqCheckOtpRes)) {
       if (reqCheckOtpRes.IsValid) {
          $("#frmReqNewDoc").show();
          this.showOtp = false;
          await this.save(); 
          if(this.saveOK)
          {
           window.location.reload();
          }
        }
        else {
          this.util.ShowWaiting(false)
          this.util.WarningDialog("รหัส OTP ที่ท่านกรอกไม่ถูกต้อง")
        }
      }
      else {
        this.util.ShowWaiting(false)
        this.util.WarningDialog("พบข้อผิดพลาดในการยืนยันรหัส OTP กรูณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่")
      }
    }
    else {
      this.util.WarningDialog("กรุณาระบุรหัส OTP")
    }
  }


  ShowDetail(drosReqNo: string) {
    let objDetail: any = this.crm08DROSList.find((e: { DROSRequestNo: string; }) => e.DROSRequestNo === drosReqNo);
    if(!this.util.IsNullOrUndefined(objDetail.ErrorMessage))
    {
      this.util.WarningDialog(objDetail.ErrorMessage); 
    }
    let addr: any = this.combinedAddressList.filter((a: any) => a.id.split('|')[0] == objDetail.LocationCode)
    $("#lblFullname").empty().text(this.contactDROS.CRM06.Name);
    $("#lblPhoneNo").empty().text(objDetail.PhoneNo);
    $("#lblDROSReqNo").empty().text(objDetail.DROSRequestNo);

    let fullAdress: string = "";
    if (!this.util.IsNullOrUndefined(objDetail.Address)) {
      fullAdress += objDetail.Address;
    }
    if (!this.util.IsNullOrUndefined(objDetail.MooNo)) {
      fullAdress += " หมู่ที่ " + objDetail.MooNo;
    }
    if (!this.util.IsNullOrUndefined(objDetail.StreetName)) {
      fullAdress += " ถนน" + objDetail.StreetName;
    }

    if(addr.length>0){
      let tmpAddr: string[] = addr[0].text.split('|');
      for (let i = 0; i < tmpAddr.length; i++) {
        if (i == 0) { fullAdress += " แขวง/ตำบล " + tmpAddr[i]; }
        if (i == 1) { fullAdress += " เขต/อำเภอ " + tmpAddr[i]; }
        if (i == 2) { fullAdress += " จังหวัด" + tmpAddr[i]; }
        if (i == 3) { fullAdress += tmpAddr[i] == objDetail.Zipcode ? " ไปรษณีย์ " + tmpAddr[i] : " ไปรษณีย์ " + objDetail.Zipcode; }
        if (i == 4) { fullAdress += " ประเทศ " + tmpAddr[i]; }
      }
    }

    $("#lblAddress").empty().text(fullAdress);

    let progress1 = '<li class="active step0"><img id="imgStatus01" class="img-fluid" width="101" style="background-color: white;" src="../../assets/images/icon_inprogress1.png"><br><span style="color: black;">ได้รับคำขอ</span>  </li> ';
    let progress2 = '<li class="active step0"><img id="imgStatus02" class="img-fluid" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress2.png"><br><span style="color: black;">อยู่ระหว่างจัดทำเอกสาร</span>   </li>';
    let progress3 = '<li class="active step0"><img id="imgStatus03" class="img-fluid" width="101" style="background-color: white;"  src="../../assets/images/icon_inprogress3.png"><br><span style="color: black;">ดำเนินการจัดส่งเอกสาร</span>   </li>';

    switch (objDetail.ProcessStatus) {
      case "ส่งสำเร็จ": {
        let li = progress1  + progress2 + progress3;
        $("#progressbarimg").append(li)
        $("#imgStatus01").attr("src", "../../assets/images/circle_1.png");
        $("#imgStatus02").attr("src", "../../assets/images/circle_1.png");
        $("#imgStatus03").attr("src", "../../assets/images/checked.png");
        break;
      }
      case "อยู่ระหว่างจัดพิมพ์": {
        let li = progress1  + progress2;
        $("#progressbarimg").append(li)
        $("#imgStatus01").attr("src", "../../assets/images/circle_1.png");
        $("#imgStatus02").attr("src", "../../assets/images/checked.png");
        
        //$("#imgStatus03").attr("src", "../../assets/images/icon_inprogress3.png");
        break;
      }
      case "ยื่นคำขอเอกสารใหม่":
      case "ได้รับข้อมูล": {
        $("#progressbarimg").append(progress1)
        $("#imgStatus01").attr("src", "../../assets/images/checked.png");
        
        //$("#imgStatus02").attr("src", "../../assets/images/icon_inprogress2.png");
       // $("#imgStatus03").attr("src", "../../assets/images/icon_inprogress3.png");
        break;
      }
      default: {
        $("#progressbarimg").append(progress1)
        $("#imgStatus01").attr("src", "../../assets/images/circle.png");
       
        //$("#imgStatus02").attr("src", "../../assets/images/icon_inprogress2.png");
        //$("#imgStatus03").attr("src", "../../assets/images/icon_inprogress3.png");
        break;
      }
    }


    $("#frmStatusReqNewDoc").removeClass("animate-opacity").addClass("hideDiv");
    $("#divDetail").removeClass("hideDiv").addClass("animate-opacity");
    //console.log(objDetail);
    // console.log(this.contactDROS.CRM06);
  }

  BackToList() {
    $("#divDetail").removeClass("animate-opacity").addClass("hideDiv");
    $("#frmStatusReqNewDoc").removeClass("hideDiv").addClass("animate-opacity");

  }
}



// WEBPACK FOOTER //
// ./src/app/request-document/request-document.component.ts